/**
 * ie-11 and older browser compatibility.
 * These can be removed when we're no longer supporting older browsers.
 */
require('custom-event-polyfill');
require('date-input-polyfill');
require('abortcontroller-polyfill/dist/polyfill-patch-fetch')
require('element-closest-polyfill');
require('classlist-polyfill');
require('url-search-params-polyfill');
require('formdata-polyfill');
require ('array-from-polyfill');
require ('array-findindex-polyfill');
require('element-remove');

//above fold content


//require('ie-array-find-polyfill');
import Vue from 'vue';
//import App from './app.vue';
import WishlistSummary from './vue-components/wishlist.vue';
import CartSummary from './vue-components/cart-summary.vue';
import addToCart from './vue-components/add-to-cart.vue';
import addToWishlist from './vue-components/add-to-wishlist.vue';
import giftOptions from './vue-components/gift-options.vue';
import addGiftOptionButton from './vue-components/add-gift-option-button.vue';
import search from './vue-components/search.vue';

function unwrap(div) {
	// place childNodes in document fragment
	var docFrag = document.createDocumentFragment();
	while (div.firstChild) {
		var child = div.removeChild(div.firstChild);
		docFrag.appendChild(child);
	}

	// replace div with document fragment
	div.parentNode.replaceChild(docFrag, div);
}

fetch('/actions/ajax/csrf/token').then(async function(result) {
  window.csrfTokenValue  = await result.text();
}).then(() => {



  document.addEventListener('afterBlitzInject', function (event) {
    var wrapper = event.detail.element;

    // Move all children out of the wrapper to right before the wrapper
    while (wrapper.firstChild) {
        wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
    }
    
    // Remove the now-empty wrapper
    wrapper.parentNode.removeChild(wrapper);
  });
  document.addEventListener('afterBlitzInjectAll', function (event) {
    let loadingAnimation = document.querySelector('.blitz-loading');
    if(loadingAnimation !== null) {
      document.querySelector('.blitz-loading').remove();
    }

    Vue.config.ignoredElements = ['iframe'];

    window.vueMain = new Vue({ el: '#vue-container',

      data: {
        searchFilter: "", // Centralized filter state
      },
      methods: {
        handleSearchUpdate(newFilter) {
          console.log("Filter updated in parent:", newFilter);
          this.searchFilter = newFilter;
        },
      },
      components: {
        WishlistSummary,
        CartSummary,
        giftOptions,
        addToCart,
        addToWishlist,
        addGiftOptionButton,
        search
      }
    });
    
    window.refs = vueMain.$refs;
    require('./layout/header');
    require('./layout/popout-menu');
    require('./components/collage');
    require('./components/accordion');
    require('./components/scroll-indicator');
    require('./components/scroll-to-content');
    require('./components/vimeo');
    require('./components/dropdown');
    require('./components/product-list-modal');
    require('./components/back-button');
    require('./components/website-search-input');
    require('./layout/watch-viewport');
    require('./product-main');
    require('./utilities/text-break');
    require('./utilities/sharing');
    require('./utilities/modal');
    require('./layout/exceptions-list');
    require('./layout/forms');
    require('./utilities/collapsible-panels');
    require('./utilities/toggle-target');
    require('./utilities/inputMask');
    require('./shop/tabbed-panels');
    require('./shop/vintage-slider');
    require('./shop/ajax-actions/index');
    //require('./components/card');
    require('./members/newsletter-subscribe');
    require('./utilities/pagination');
    require('./events/eventCalendarView');
    require('./events/eventDatePicker');
    require('./events/eventViewSwitch');
    require('./shop/ajax-filters');
    require('./shop/ajax-actions/load-filtered-results');
    require('./events/load-filtered-events');
    require('./shop/single-page-checkout/index');
    require('./members/forms'); // Used for member related forms: Signin, Register, Forgot Password etc.
    require('./contact-form');
    require('./shop/pre-fill-address');
    require('./components/accept-cookies');
    require('./components/carousel');

    require('./layout/hero');
    require('./components/hero-carousel');



    function loadRecaptcha() {
      var script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?onload=CaptchaCallback&render=explicit';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    loadRecaptcha();
    


    // Failsafe
    if(document.querySelector('iframe.rezdy') != null) {
      setTimeout(() => { //wait 2.5 seconds for the iframe to re-adjust 
        document.querySelector('iframe.rezdy').style.opacity = 1;
        document.querySelector('.loading-icon').style.display='none';
      }, 6000);
    }


        // Failsafe
        function waitForGleamWidget() {
          const widget = document.querySelector('.e-widget-wrapper');
      
          if (widget != null) {
              setTimeout(() => {
                  widget.querySelector('iframe').style.position = 'static';

                  let preloader = document.querySelector('.e-widget-preloader');

                  if(preloader !== null) {
                    document.querySelector('.e-widget-preloader').style.display = 'none';
                  }
              }, 1000); // Wait 1 seconds for the iframe to re-adjust
          } else if (performance.now() - startTime < 30000) { // Check if less than 10 seconds have passed
              setTimeout(waitForGleamWidget, 300); // Check again in 100ms
          } else {
              console.log('Gleam widget not found after 10 seconds.');
          }
      }
      
      const startTime = performance.now(); // Record the start time
      waitForGleamWidget();

  
  if(document.getElementById('map')) {
  
    var map,
    EasingAnimator = function(opt){
        opt = opt || {};
        this.easingInterval = opt.easingInterval;
        this.duration = opt.duration || 1000;
        this.step = opt.step || 50;
        this.easingFn = opt.easingFn  || function easeInOutElastic(t, b, c, d) {
            if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
            return -c/2 * ((t-=2)*t*t*t - 2) + b;
        };
        this.callBack = opt.callBack || function(){};
    };
    EasingAnimator.makeFromCallback = function(callBack){
    return new EasingAnimator({
        callBack: callBack
    });
    };
    EasingAnimator.prototype.easeProp = function(obj, propDict){
    propDict = propDict || {};
    
    var self = this,
        t = 0,
        out_vals = JSON.parse(JSON.stringify(obj));
    
    clearInterval(self.easingInterval);
    self.easingInterval = setInterval(function(){
        t+= self.step;
        if (t >= self.duration) {
            clearInterval(self.easingInterval);
            self.callBack(propDict);
            return;
        }
        var percent = self.easingFn(t, 0, 1, self.duration);
        Object.keys(propDict).forEach(function(key, i) {
            var old_val = obj[key];
            
            out_vals[key] = old_val - percent*(old_val - propDict[key]);
        });
        self.callBack(out_vals);
    }, self.step);
    };
    
    function fitBounds(points) {
      var bounds = new google.maps.LatLngBounds();
      for (var i = 0; i < points.length; i++) {
        bounds.extend(points[i]);
      }
      
      map.fitBounds(bounds);
    }
    function initialize() {
    var points = [];
    window.points = points;
    document.querySelectorAll('.map-locations').forEach(function(locations) {
      locations.querySelectorAll('li').forEach(function(li) {
        li.querySelectorAll('.event-location').forEach(function(item) {
          points.push({ 'lat' : item.dataset.lat*1, 'lng' : item.dataset.lng*1, 'icon': { 
            url: item.dataset.icon, 
            scaledSize: new google.maps.Size(35, 50) 
          } })
        });
      });
    });
    
      var sel_point = 0;
    
    map = new google.maps.Map(document.getElementById('map'), {
        zoom: 10,
        center: points[sel_point],
        mapTypeControl: false,
        
        streetViewControl: false
    });
  
    
    var stylez = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [
          { saturation: -50 } // <-- THIS
        ]
      }
    ];
    var mapType = new google.maps.StyledMapType(stylez, { name:"Grayscale" });    
    map.mapTypes.set('tehgrayz', mapType);
    map.setMapTypeId('tehgrayz');
    
    if(points.length > 1) {
      fitBounds(points);
    }
    
    points.forEach(function(point) {
      var marker2 = new google.maps.Marker({
        position: point,
        map: map,
        icon: point.icon
      });
    });
    
    var easingAnimator = EasingAnimator.makeFromCallback(function(latLng){
        map.setCenter(latLng) 
    })
    Array.prototype.slice.apply(document.querySelectorAll('.map-locations li'))
        .map(function(dom_elem, i) {
            dom_elem.addEventListener('click', function(event){
              // get points
              var markers = [];
              dom_elem.querySelectorAll('.event-location').forEach(function(item) {
                markers.push({ 'lat' : item.dataset.lat*1, 'lng' : item.dataset.lng*1 })
              });
                var point = map.getCenter();
                easingAnimator.easeProp(markers[0], markers[0]);
    
    
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < markers.length; i++) {
                bounds.extend(markers[i]);
                }
    
                map.fitBounds(bounds);
                var zoom = map.getZoom();
                map.setZoom(zoom > 12 ? 12 : zoom);
            });
    });
    }
    setTimeout(function() {
    
      initialize();
    
    }, 2000);
  
    document.querySelectorAll('.map-locations__button').forEach(function(button) {
      button.addEventListener('click', function() {
  
        document.querySelectorAll('.map-locations__button').forEach(function(item) {
          item.classList.remove('active');
        });
  
        button.classList.add('active');
      });
    });
  }
  
  
  //addEventListener("resize", (event) => {
    if(!document.querySelectorAll('.js-breakpoint-hint-desktop')[0].getClientRects().length) { // check if it's mobile vs desktop.
      let shopFilters = document.querySelector('.search-header-container--shop');
      let navTabs = document.querySelector('.secondary-navigation__tabs');
      if(shopFilters !== null && navTabs !== null) {
        let filterContainer = shopFilters.parentElement;
  
        let d = document.createElement('div');
        d.classList.add('open-nav');
        d.innerText = navTabs.firstChild.textContent;
        d.innerHTML = `${navTabs.firstChild.textContent} <svg class="hero__scroll-icon"><use xlink:href="#chev-down"></use></svg>`;
  
        filterContainer.prepend(d);
        filterContainer.classList.add('filter-section--shop');
  
        document.querySelector('.open-nav').addEventListener('click', (e) => {
          navTabs.classList.toggle('active');
        });
      }
    }
  //});
  



  });
});

